import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";
import { project, task } from "@planzone/dto";
import { useModal } from "@root/client/modal";
import { MemberAvatar } from "@common/memberAvatar";

import { Breadcrumbs } from "../breadcrumbs";
import { CreationDate } from "../date";
import { Props } from "./types";
import styles from "./styles.scss";

function AddedToTask({ notification, close }: Props) {
  const { pushView } = useModal();
  const { t } = useTranslation();
  const push = useNavigate();

  return (
    <div className={styles.notification}>
      <div className={styles.header}>
        <Breadcrumbs
          breadcrumbs={[
            {
              name: notification.data.zoneName,
              click: () => push(`/zones/${notification.data.zoneID}`),
            },
            {
              name: notification.data.projectName,
              click: () => {
                push(`/projects/${notification.data.projectId}`);
                close && close();
              },
            },
            {
              name: notification.data.taskName,
              click: () => {
                pushView({
                  key: UseCases.retrieveTask,
                  data: {
                    task: {
                      ...task,
                      uuid: notification.data.taskId,
                      name: notification.data.taskName,
                    },
                    isMultiProject: true,
                  },
                });
                close && close();
              },
            },
          ]}
        />
        <CreationDate date={notification.createdDate} />
      </div>
      <div className={styles.main}>
        <div className={styles.author}>
          <div className={styles.avatar}>
            <MemberAvatar name={notification.data.authorName} avatarUrl="" />
          </div>
          <p className={styles.authorName}>{notification.data.authorName}</p>
        </div>
        <p className={styles.text}>
          {` ${t("notifications.addedToTask.assigned")} : `}
        </p>
        <p
          className={styles.task}
          onClick={() => {
            close && close();
            pushView({
              key: UseCases.retrieveTask,
              data: {
                task: {
                  ...task,
                  uuid: notification.data.taskId,
                  name: notification.data.taskName,
                },
                isMultiProject: true,
              },
            });
          }}
        >
          {notification.data.taskName}
        </p>
      </div>
    </div>
  );
}

export { AddedToTask };
